import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const pathStopsApiRoutes = {
    listStops: apiBusSchedBaseURL + "pathstops/stops/",
    listComplementaryStops: apiBusSchedBaseURL + "pathstops/complementaryStops/",
    listLines: apiBusSchedBaseURL + "pathstops/lines/",
};

export class PathStopAPI {
    static listStops(networkEdition, lineId) {
        const url = new URL(`${networkEdition}/${lineId}`, pathStopsApiRoutes.listStops);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }

    static listComplementaryStops(networkEdition, lineIds) {
        const url = new URL(`${networkEdition}/${lineIds}`, pathStopsApiRoutes.listComplementaryStops);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }

    static listLines(networkEdition, stopId) {
        const url = new URL(`${networkEdition}/${stopId}`, pathStopsApiRoutes.listLines);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/bussched/PathStopAPI.js